import React, { useContext, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';

import { ReactComponent as QuestionIcon } from "../../../static/icons/question-circle.svg";
import { ReactComponent as Triangle } from "../../../static/icons/triangle.svg";
import "./DropDownSupport.scss";
import { ModalContext } from "../../ModalContext";
import SupportModal from "../../modals/SupportModal";
import { useOnClickOutside } from "../../../utils/helpers";

const SupportDropDown = () => {
  const { t } = useTranslation();

  const [toggleDropDown, setToggleDropDown] = useState(false);
  const { handleModal } = useContext(ModalContext);
  const ref = useRef();

  const handleContactSupportClick = () => {
    handleModal(
      <SupportModal />,
      false,
      true,
    );
  };
  const handleToggleDropDown = () => {
    setToggleDropDown(prevState => !prevState);
  };
  useOnClickOutside(ref, () => {
    setToggleDropDown(false);
  });
  return (
    <div
      ref={ref}
      className="support-drop-down"
      onClick={handleToggleDropDown}
    >
      <div className={"support-drop-down__btn"}>
        <QuestionIcon
          className={`${toggleDropDown ? "icon-circle-orange" : ""}`}
        />
        <Triangle className={`${toggleDropDown ? "icon-background-orange" : ""}`} />
      </div>
      <div className={`support-drop-down__wrapper ${toggleDropDown ? "active-drop-down" : ""}`}>
        <div className={"support-drop-down__body"}>
            <a target={"_blank"} href={"https://bim-search.com/en/helpcenter/"} rel={"noreferrer"}>{t('help_center')}</a>
          <span onClick={handleContactSupportClick}>{t('contact_support')}</span>
        </div>
      </div>
    </div>
  );
};

export default SupportDropDown;
